import React, { useState, useEffect, useRef } from "react";
import LeaveCheckout from "./LeaveCheckout";
import { Link } from "react-router-dom";
import { ClipLoader } from 'react-spinners';
import calendarVector from "../../../Asset/Events/calendar-vector.svg";
import locationVector from "../../../Asset/Events/location-vector.svg";
import timeVector from "../../../Asset/Events/time-vector.svg";
import coinVector from "../../../Asset/Events/coin-vector.svg";
import { format } from "date-fns";
import axios from "axios";
import { useParams } from "react-router-dom";
import './CheckoutModal.css'
import DownArrow from "../../../Asset/CheckoutModal/down-arrow-checkout-modal.svg"
import SplitPaymentCard from "../../../Asset/CheckoutModal/split-payment-msg-card.svg"
import SplitPaymentMobile from "../../../Asset/CheckoutModal/split-payment-mobile.svg";
import SinglePersonLogo from "../../../Asset/CheckoutModal/single-person-logo.svg"
import MultiplePersonLogo from "../../../Asset/CheckoutModal/multiple-person-logo.svg"
import UncheckedRadio from "../../../Asset/CheckoutModal/unchecked-radio-btn.svg"
import CheckedRadio from "../../../Asset/CheckoutModal/checked-radio-btn.svg"
import SplitPaymentOverlayBackground from "../../../Asset/CheckoutModal/split-payment-purple-background.png"
import infoIcon from "../../../Asset/CheckoutModal/i-icon.svg"
import { formatPrice } from "../../utils/price";



const CheckoutModal = ({ isOpen, closeModal, count, eventData, addToWaitlist, alreadyOnWaitlist, havePartnerFlag }) => {
  const [showLeaveModal, setShowLeaveModal] = useState(false);
  const [formattedDates, setFormattedDates] = useState({});
  let { eventId } = useParams();
  const [errors, setErrors] = useState({});
  const [teamErrors, setTeamErrors] = useState([]);
  const [loading, setLoading] = useState(false);

  const [showTeamForm, setShowTeamForm] = useState(false)
  const [showSplitPaymentView, setShowSplitPaymentView] = useState(false)
  const [splitPaymentValue, setSplitPaymentValue] = useState(null)

  const [paymentSplitRadioBtn, setPaymentSplitRadioBtn] = useState(false)
  const [paymentNonSplitRadioBtn, setPaymentNonSplitRadioBtn] = useState(false)

  const [errorDisplayMessage, setErrorDisplayMessage] = useState("");
  const [showOverlayModal, setShowOverlayModal] = useState(false);

  const [isMobileEventAccordionOpen, setIsMobileEventAccordionOpen] = useState(true);

  const chooseWhoPaysRef = useRef(null);
  const [hasAutoScrolledToPayment, setHasAutoScrolledToPayment] = useState(false);
  const [submitAttempted, setSubmitAttempted] = useState(false);
  const [touched, setTouched] = useState({});
  const [teamTouched, setTeamTouched] = useState([]);
  const [chooseWhoPaysTouched, setChooseWhoPaysTouched] = useState(false);

  const shouldShowError = (field) => {
    return !!(submitAttempted || touched?.[field]);
  };

  const shouldShowTeamError = (index, field) => {
    return !!(submitAttempted || teamTouched?.[index]?.[field]);
  };

  const getFieldError = (field, value) => {
    if (field === 'FirstName') return value && String(value).trim() ? '' : 'First name is required.';
    if (field === 'LastName') return value && String(value).trim() ? '' : 'Last name is required.';
    if (field === 'Email') {
      if (!value || !String(value).trim()) return 'Email is required.';
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(String(value)) ? '' : 'Enter a valid email address.';
    }
    if (field === 'Phone') {
      if (!value || !String(value).trim()) return 'Mobile number is required.';
      const digits = String(value).replace(/\D/g, '');
      return digits.length === 10 ? '' : 'Enter a valid 10-digit mobile number.';
    }
    if (field === 'Gender') return value ? '' : 'Please select a gender.';
    if (field === 'agreeTerms') return value ? '' : 'Please agree to the Terms of Service.';
    return '';
  };

  const [formData, setFormData] = useState({
    Email: "",
    Phone: "",
    ext: "",
    Gender: "", // Default to "Man"
    FirstName: "",
    LastName: "",
    org_id: "",
    role: "General", // Default role to "General"
    agreeTerms: false,
    subscribeUpdates: false
  });

  // State for team members
  const [teamMembers, setTeamMembers] = useState(
    Array.from({ length: count }, () => ({
      FirstName: '',
      LastName: '',
      Phone: '',

      Email: null,

      Gender: '' // Initialize with empty string
    }))
  );

  useEffect(() => {
    setTeamTouched(Array.from({ length: count }, (_, i) => teamTouched[i] || {}));
  }, [count]);

  // State to store user ID from the signup response
  const [userId, setUserId] = useState(null);
  const [orderId, setOrderId] = useState(null);

  // Check if all input fields are filled and checkbox is checked
  const isFormValid =
    formData.FirstName.trim() !== '' &&
    formData.LastName.trim() !== '' &&
    formData.Email.trim() !== '' &&
    formData.Phone.trim() !== '' &&
    formData.Gender !== '' &&
    formData.agreeTerms && // Validate the single agreeTerms checkbox
    (splitPaymentValue != null || eventData.isFull)  // Ensure splitPaymentValue is selected unless event is full
    &&
    teamMembers.every(
      (member) =>
        member.FirstName.trim() !== '' &&
        member.LastName.trim() !== '' &&
        member.Phone.trim() !== '' &&
        member.Gender !== ''
    );

  // Handle input change for signup form
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    // setFormData((prevData) => ({
    //   ...prevData,
    //   [name]: value,
    // }));

    const prevValue = formData?.[name];
    const nextValue = type === 'checkbox' ? checked : value;
    if (
      typeof window !== 'undefined' &&
      window.matchMedia?.('(max-width: 767px)')?.matches &&
      isMobileEventAccordionOpen &&
      type !== 'checkbox' &&
      typeof prevValue === 'string' &&
      typeof nextValue === 'string' &&
      prevValue.trim() === '' &&
      nextValue.trim() !== ''
    ) {
      setIsMobileEventAccordionOpen(false);
    }

    setFormData({
      ...formData,
      [name]: nextValue
    });

    if (name) {
      setTouched((prev) => ({ ...(prev || {}), [name]: true }));
    }

    if (
      name === 'FirstName' ||
      name === 'LastName' ||
      name === 'Email' ||
      name === 'Phone' ||
      name === 'Gender' ||
      name === 'agreeTerms'
    ) {
      const msg = getFieldError(name, nextValue);
      setErrors((prev) => {
        const next = { ...(prev || {}) };
        if (msg) next[name] = msg;
        else delete next[name];
        return next;
      });
    }

    const updatedTeamMembers = [...teamMembers];
    updatedTeamMembers[0][name] = value;
    setTeamMembers(updatedTeamMembers);
  };

  // Handle input change for individual fields
  const handleTeamInputChange = (index, field, value) => {
    const updatedTeamMembers = [...teamMembers];
    const prevValue = updatedTeamMembers?.[index]?.[field];
    updatedTeamMembers[index][field] = value;
    setTeamMembers(updatedTeamMembers);

    if (field === 'FirstName' || field === 'LastName' || field === 'Phone' || field === 'Gender') {
      const msg = getFieldError(field, value);
      setTeamTouched((prev) => {
        const next = Array.isArray(prev) ? [...prev] : [];
        next[index] = { ...(next[index] || {}), [field]: true };
        return next;
      });
      setTeamErrors((prev) => {
        const next = Array.isArray(prev) ? [...prev] : [];
        const row = { ...(next[index] || {}) };
        if (msg) row[field] = msg;
        else delete row[field];
        next[index] = row;
        return next;
      });
    }
    if (
      typeof window !== 'undefined' &&
      window.matchMedia?.('(max-width: 767px)')?.matches &&
      isMobileEventAccordionOpen &&
      typeof prevValue === 'string' &&
      typeof value === 'string' &&
      prevValue.trim() === '' &&
      value.trim() !== ''
    ) {
      setIsMobileEventAccordionOpen(false);
    }

    if (
      field === 'Phone' &&
      index === count - 1 &&
      typeof prevValue === 'string' &&
      typeof value === 'string'
    ) {
      const prevDigits = prevValue.replace(/\D/g, '');
      const nextDigits = value.replace(/\D/g, '');
      if (prevDigits.length < 10 && nextDigits.length === 10) {
        if (!eventData?.isFull && count > 1) {
          setShowSplitPaymentView(true);
          if (!hasAutoScrolledToPayment) {
            setHasAutoScrolledToPayment(true);
            setTimeout(() => {
              chooseWhoPaysRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 0);
          }
        }
      }
    }
    // validateFields(field);
  };

  //validating form fields
  const validateFields = () => {
    const newErrors = {};
    if (!formData.FirstName) newErrors.FirstName = 'First name is required.';
    if (!formData.LastName) newErrors.LastName = 'Last name is required.';
    if (!formData.Email) {
      newErrors.Email = 'Email is required.';
    } else if (!validateEmail(formData.Email)) {
      newErrors.Email = 'Enter a valid email address.';
    }
    if (!formData.Phone) {
      newErrors.Phone = 'Mobile number is required.';
    } else if (!validateMobile(formData.Phone)) {
      newErrors.Phone = 'Enter a valid 10-digit mobile number.';
    }
    if (!formData.Gender) newErrors.Gender = 'Please select a gender.';
    if (!formData.agreeTerms) newErrors.agreeTerms = 'Please agree to the Terms of Service.';

    const teamValid = validateTeamMembers();
    const chooseWhoPaysValid = eventData.isFull || count <= 1 || splitPaymentValue !== null;

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0 && teamValid && chooseWhoPaysValid;
  };

  const toggleFormView = () => {
    setShowTeamForm((prev) => {
      const next = !prev;
      if (next && count > 1 && !eventData?.isFull) {
        setShowSplitPaymentView(true);
      }
      return next;
    });
  }
  const toggleSplitPaymentView = () => {
    setShowSplitPaymentView(!showSplitPaymentView)
  }
  const handleSplitScenario = () => {
    setPaymentNonSplitRadioBtn(false)
    setPaymentSplitRadioBtn(true)
    setSplitPaymentValue(true)
    setChooseWhoPaysTouched(true)
  }
  const handleNonSplitScenario = () => {
    setPaymentNonSplitRadioBtn(true)
    setPaymentSplitRadioBtn(false)
    setSplitPaymentValue(false)
    setChooseWhoPaysTouched(true)
  }
  useEffect(() => {
    if (count <= 1 || eventData.isFull) {
      setSplitPaymentValue(false);
    }
  }, [count]);

  useEffect(() => {
    if (isOpen) {
      setIsMobileEventAccordionOpen(true);
      setHasAutoScrolledToPayment(false);
    }
  }, [isOpen]);

  // Show overlay modal after 2 seconds when count > 1 and modal is opened
  // useEffect(() => {
  //   if (isOpen && count > 1) {
  //     const timer = setTimeout(() => {
  //       setShowOverlayModal(true);
  //     }, 1000);

  //     return () => clearTimeout(timer);
  //   }
  // }, [isOpen, count]);
  console.log("split payment value: ", splitPaymentValue)
  const validateTeamMembers = () => {
    const newErrors = teamMembers.map((member) => {
      let memberErrors = {};
      if (!member.FirstName) memberErrors.FirstName = 'First name is required.';
      if (!member.LastName) memberErrors.LastName = 'Last name is required.';
      if (!member.Phone) {
        memberErrors.Phone = 'Mobile number is required.';
      } else if (!validateMobile(member.Phone)) {
        memberErrors.Phone = 'Enter a valid 10-digit mobile number.';
      }
      if (!member.Gender) memberErrors.Gender = 'Please select a gender.';

      return memberErrors;
    });

    setTeamErrors(newErrors);

    // Check if there are no errors
    return newErrors.every((error) => Object.keys(error).length === 0);
  };

  const validateEmail = (Email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(Email);

  };

  const validateMobile = (Phone) => {
    const mobileRegex = /^[0-9]{10}$/;
    return mobileRegex.test(Phone);
  };

  // Function to handle form submission for signup, orders and checkout endpoints
  const handleSubmit = async (e) => {
    setErrorDisplayMessage("")
    e.stopPropagation();
    e.preventDefault();
    setSubmitAttempted(true);
    setChooseWhoPaysTouched(true);
    if (!validateFields()) {
      return;
    }

    setLoading(true); // Show loader

    try {


      // Check if the user already exists using the /users/profile/{MobileNumber} endpoint
      let id; // Initialize the variable to store user ID
      try {
        const profileResponse = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/users/profile/${formData.Phone}`,
          {
            headers: {
              "Content-Type": "application/json",
              accept: "application/json",
            },
          }
        );

        // If the user exists, get the user ID
        const { UserId } = profileResponse.data; // Destructure UserId from the response
        id = UserId; // Assign the user ID to the variable

      } catch (error) {
        if (error.response && (error.response.status === 500 || error.response.status === 404)) {

          let signupResponse;
          try {
            signupResponse = await axios.post(
              `${process.env.REACT_APP_BASE_URL}/signup/`,
              {
                email: formData.Email,
                mobile: formData.Phone,
                first_name: formData.FirstName,
                last_name: formData.LastName,
                org_id: formData.org_id || "", // Ensure org_id is included or defaults to empty string
                role: formData.role,
                ext: formData.ext || "+91", // Optional
                gender: formData.Gender,
              },
              {
                headers: {
                  "Content-Type": "application/json",
                  accept: "application/json",
                },
              }
            );

            // Extract and store ID from the /signup response
            id = signupResponse.data.id; // Assign the user ID directly
            setUserId(id);
          } catch (error) {
            if (error.response && error.response.status == 409) {
              setErrorDisplayMessage("Oops! This number or email is already linked to a registration. Please try a different one.")
            }
          }

        } else {
          console.error("Error during user profile check:", error);
          throw error; // Re-throw error to exit the process
        }
      }

      // Now, make the POST request to the /orders endpoint using the userId
      let orderResponse;
      let SubOrderId
      let WaitlistId
      try {
        orderResponse = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/create/event/orders/`,
          {
            EventId: eventId,
            primaryUserId: id, // Use the ID returned from the signup response
            OrderData: {
              Team: teamMembers
            },
            "HasPartner": havePartnerFlag,
            "IsUsingCredits": false,
            "PutOnWaitlist": eventData.isFull || false,
            "Split": splitPaymentValue,
            WaitlistOrderId: null, // Optional, can be left blank if not provided
          },
          {
            headers: {
              "Content-Type": "application/json",
              accept: "application/json",
            },
          }
        );

        console.log("Order Response:", orderResponse);
        console.log('order response data:', orderResponse.data)

        const SubOrderIdList = orderResponse.data.SubOrderIdList;
        console.log(' suborder id list:', SubOrderIdList)
        WaitlistId = orderResponse.data.WaitlistId;

        if (Array.isArray(SubOrderIdList)) {
          console.log('in here?')
          SubOrderId =
            SubOrderIdList.find((suborder) => suborder.UserId === id)?.SubOrderId || null;

          console.log('suborder id:', SubOrderId)
        }

        console.log('waitlist id:', WaitlistId);
        if (SubOrderId != null) {
          console.log('coming here')
          setOrderId(SubOrderId);
        } else if (WaitlistId) {
          console.log('inside waitlist id case');
          addToWaitlist(true);
          alreadyOnWaitlist(false);
          closeModal();
        }



      } catch (error) {
        const errorMessage = error.response.data.detail;
        console.error(errorMessage);
        if (error.response && error.response.status === 400) {
          setErrorDisplayMessage("Error: User is already part of the event.")
        }
        if (error.response && error.response.status === 409) {

          if (errorMessage.includes('waitlist')) {
            addToWaitlist(false);
            alreadyOnWaitlist(true);
            closeModal()
          }
          else if (errorMessage.includes('User')) {
            setErrorDisplayMessage("Oops! This number or email is already linked to a registration. Please try a different one.")
          }
          else if (errorMessage.includes('same number')) {
            setErrorDisplayMessage("Oops! This number or email is already linked to a registration. Please try a different one.")
          } else {
            setErrorDisplayMessage("Oops! Some error occurred while creating the order.")
          }
        }
        console.error("Error during order creation:", error);
        return
      }


      // Checkout Endpoint code here
      // Finally, make the POST request to the /checkout endpoint using the generated OrderId

      let checkoutResponse
      try {
        checkoutResponse = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/checkout/?sub_order_id=${SubOrderId}`,
          {},
          {
            headers: {
              "Content-Type": "application/json",
              accept: "application/json",
            },
          }
        );


      } catch (error) {

        if (error.response && error.response.status === 403) {
          setErrorDisplayMessage("You are a member! Please use mobile app to pay.")
        }
        else if (error.response && error.response.status === 409) {
          // setIsEventFull(true)
          // setIsAddedToWaitlist(false)

          //data to be sent to parent (current event)
          addToWaitlist(true);
          alreadyOnWaitlist(false);

          // isAddedToWaitlist is null so checking if user is already on waitlist
          if (error.response.data.detail.order_id?.length > 0) {

            //data to be sent to parent (current event)
            addToWaitlist(false);
            alreadyOnWaitlist(true);
            //  closeModal()

          } else {
            setErrorDisplayMessage("Oops! Some error occured while checkout.")
          }
          closeModal();
        }


        console.error(error);


      }


      //storing data to proceed with razorpay
      const { RazorpayOrderId, Amount } = checkoutResponse.data;


      //Call Razorpay payment handling function
      handleRazorpayPayment(RazorpayOrderId, formData, Amount);
    } catch (error) {



    } finally {
      setLoading(false); // Hide loader
    }
  };


  const handleRazorpayPayment = async (RazorpayOrderId, formData, Amount) => {
    let amount
    amount = Amount * 100 * count;

    //Dynamically create a form to submit to Razorpay Hosted Checkout
    const form = document.createElement("form");
    form.setAttribute("method", "POST");
    form.setAttribute(
      "action",
      "https://api.razorpay.com/v1/checkout/embedded"
    );
    // form.setAttribute("target", "_blank");

    //Define form fields dynamically
    const fields = [
      { name: "key_id", value: `${process.env.REACT_APP_RAZORPAY_ID}` }, // Razorpay key ID
      { name: "order_id", value: RazorpayOrderId }, // The order ID returned from backend
      { name: "amount", value: amount * 100 }, // Amount 
      { name: "currency", value: "INR" },

      { name: "name", value: "Net Gala" },
      { name: "description", value: "Please complete your payment to proceed." },
      { name: "image", value: `${process.env.REACT_APP_HOSTED_URL}/logo.png` }, // Company logo or product image

      {
        name: "callback_url",
        value: `${process.env.REACT_APP_BASE_URL}/payment/callback/`,
      },
      {
        name: "cancel_url",
        value: `${process.env.REACT_APP_BASE_URL}/payment/cancel/${RazorpayOrderId}`,
      },
      { name: "prefill[name]", value: formData.FirstName }, // Optional pre-fill for name
      { name: "prefill[contact]", value: formData.Phone }, // Optional pre-fill for contact
      { name: "prefill[email]", value: formData.Email }, // Optional pre-fill for Email
    ];

    //Append fields to the form
    fields.forEach(({ name, value }) => {
      const input = document.createElement("input");
      input.setAttribute("type", "hidden");
      input.setAttribute("name", name);
      input.setAttribute("value", value);
      form.appendChild(input);
    });

    // Append form to the body and submit it automatically
    document.body.appendChild(form);
    form.submit();
  };



  // Format dates when eventData is received
  useEffect(() => {
    if (eventData?.EventSchedule) {
      const startDate = format(new Date(eventData.EventSchedule.StartTimeStamp), "do MMMM");
      const endDate = format(new Date(eventData.EventSchedule.EndTimeStamp), "do MMMM");
      const registrationStartDate = format(new Date(eventData.EventSchedule.RegistrationStartTimeStamp), "dd MMM, EEEE yyyy");
      const registrationEndDate = format(new Date(eventData.EventSchedule.RegistrationEndTimeStamp), "dd MMM, EEEE yyyy");
      const StartTimeStamp = format(new Date(eventData.EventSchedule.StartTimeStamp), "h:mm a");
      const EndTimeStamp = format(new Date(eventData.EventSchedule.EndTimeStamp), "h:mm a");

      setFormattedDates({
        startDate,
        endDate,
        registrationStartDate,
        registrationEndDate,
        StartTimeStamp,
        EndTimeStamp,
      });
    }
  }, [eventData]);

  const handleCloseClick = () => {
    setShowLeaveModal(true);
  };

  const handleStayClick = () => {
    setShowLeaveModal(false);
  };

  const handleLeaveClick = () => {
    setShowLeaveModal(false);
    closeModal();
  };

  //prevents scrolling of page when modal opened and resumes scrolling when modal closed
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => document.body.style.overflow = 'unset';
  }, []);



  if (!isOpen) return null;

  return (
    <div id="blackOverView-checkout" className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-40 object-cover">
      {!showLeaveModal ? (
        <div id="main-container-checkout" className="bg-[var(--white)] md:rounded-3xl w-full h-full md:h-auto md:w-[80vw]  md:max-h-[95vh] md:mx-4 flex flex-col md:flex-row justify-start md:justify-between relative ">
          {/* Left Side: Registration Form */}
          <div id="left-container-checkout" className="w-full md:w-[58%] border-r  md:pr-8 p-4  md:max-h-[90vh] overflow-hidden md:p-14">
            <div id="leftSide-top-heading-checkout" className="flex justify-between items-center ">
              <h2 className="text-[1.75rem] md:text-3xl lg:text-[2rem] font-medium font-ClashGrotesk text-[var(--dark-blue)]">
                Checkout
              </h2>

              {/* close buttone here */}
              <button
                className="text-gray-500 z-20 absolute top-3 right-3 md:top-3 md:right-4 md:text-xl"
                onClick={handleCloseClick}
              >
                &#x2715;
              </button>
            </div>

            <div id="leftSide-top-sub-heading-checkout" className="mt-3  flex flex-col  md:h-[50vh] h-auto ">
              <span className="mb-4 flex justify-between">
                <p className="subHeading-text text-base md:text-lg lg:text-xl font-semibold font-manrope text-[var(--dark-blue)] mb-2">Add registration details for all players</p>
                <p className="font-manrope text-xs mt-1"><span className="text-red-600">*</span> Required</p>
              </span>

              {/* Scrollable Form */}
              <div className="flex flex-col justify-start   h-full">
                <hr className="text-[var(--dull-white)] border-[1.04px] md:mb-1 hidden md:block mr-7" />
                <div id="scroll-container" className="scroll-container max-h-[40vh] md:max-h-screen md:pr-2 font-manrope  justify-center md:pb-4 overflow-y-auto">


                  {count <= 1 ? (
                    <>
                      <h1 className="text-base md:text-xs font-semibold font-manrope text-[var(--gray-brown)] md:ml-10 pt-2 md:pt-0 hidden md:block mt-3">
                        Organizer Contact Details:
                      </h1>
                      <div id="form-single-player-checkout" className="flex flex-col md:flex-row gap-4 w-full text-[var(--dark-blue)] font-manrope font-semibold border border-solid rounded-3xl md:border-none p-8 md:p-0 mt-4">
                        <p className="font-semibold font-manrope text-[var(--dark-blue)] md:hidden">Your Details</p>
                        <p className="text-[var(--dark-blue)]  border-[var(--dark-blue)] border-solid border-2 rounded-full w-6 h-6  p-2 md:flex justify-center items-center mt-2 hidden ">{"1"}</p>
                        <div className="flex flex-col w-full gap-4">
                          <div className="flex flex-col md:flex-row gap-4  ">
                            <div className="flex flex-col w-full">
                              <input required
                                type="text"
                                placeholder="First Name*"
                                name="FirstName"
                                value={formData.FirstName}
                                onChange={handleChange}
                                className={` border py-4 p-2 rounded-lg w-full  bg-[var(--white)] md:text-xs ${errors.FirstName && shouldShowError('FirstName') ? 'border-red-500' : 'border-[var(--input-border-gray)]'}`}
                              />
                              {errors.FirstName && shouldShowError('FirstName') && (
                                <p className="text-red-500 text-xs font-manrope mt-1">{errors.FirstName}</p>
                              )}
                            </div>
                            <div className="flex flex-col w-full">
                              <input required
                                type="text"
                                placeholder="Last Name*"
                                name="LastName"
                                value={formData.LastName}
                                onChange={handleChange}
                                className={`border py-4 p-2 rounded-lg w-full  bg-[var(--white)] md:text-xs ${errors.LastName && shouldShowError('LastName') ? 'border-red-500' : 'border-[var(--input-border-gray)]'} `}
                              />
                              {errors.LastName && shouldShowError('LastName') && (
                                <p className="text-red-500 text-xs font-manrope mt-1">{errors.LastName}</p>
                              )}
                            </div>
                          </div>
                          <div className="flex flex-col md:flex-row gap-4">
                            <div className="flex flex-col w-full">
                              <input
                                type="Email"
                                placeholder="Email*"
                                name="Email"
                                value={formData.Email}
                                onChange={handleChange}
                                className={`border py-4  p-2 rounded-lg w-full  bg-[var(--white)] text-[var(--dark-blue)] md:text-xs ${errors.Email && shouldShowError('Email') ? 'border-red-500' : 'border-[var(--input-border-gray)]'}`}
                              />
                              {errors.Email && shouldShowError('Email') && (
                                <p className="text-red-500 text-xs font-manrope mt-1">{errors.Email}</p>
                              )}
                            </div>
                            <div className="flex flex-col w-full">
                              <select id="custom-select-1-checkout" name="Gender" value={formData.Gender} onChange={handleChange} className={`select-button custom-select select md:py-4  md:p-2 h-[3.2rem]  w-full  bg-white max-w-xs  text-[var(--dark-blue)] bg-[(--white)] font-semibold md:text-xs ${errors.Gender && shouldShowError('Gender') ? 'border-red-500' : 'border-[var(--input-border-gray)]'} `} required>
                                <option disabled selected hidden value="" className="text-[var(--gray-brown)] font-ClashGrotesk font-medium ">Gender</option>
                                <option value="Man" >Man</option>
                                <option value="Woman" >Woman</option>
                                <option value="Non-Binary">Non-Binary</option>
                              </select>
                              {errors.Gender && shouldShowError('Gender') && (
                                <p className="text-red-500 text-xs font-manrope mt-1">{errors.Gender}</p>
                              )}
                            </div>
                            <div className="flex flex-col w-full">
                              <input
                                type="tel"
                                placeholder="Mobile*"
                                name="Phone"
                                value={formData.Phone}
                                onChange={handleChange}
                                className={`border  py-4 p-2 rounded-lg w-full  bg-[var(--white)] text-[var(--dark-blue)] md:text-xs ${errors.Phone && shouldShowError('Phone') ? 'border-red-500' : 'border-[var(--input-border-gray)]'} `}
                              />
                              {errors.Phone && shouldShowError('Phone') && (
                                <p className="text-red-500 text-xs font-manrope mt-1">{errors.Phone}</p>
                              )}
                            </div>

                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      {/* First section of the checkout modal team form  */}
                      <div id="first-section-checkout-modal" className="py-4">

                        {!showTeamForm && !eventData.isFull && (
                          <div className="ml-2">
                            <div className="flex justify-between items-center ">
                              <h1 className="text-[var(--dark-blue)] text-[1.5rem] font-ClashGrotesk font-medium">1.<span className="ml-3">Pick your team</span> </h1>
                              <img onClick={toggleFormView}
                                src={DownArrow} className="cursor-pointer mr-7" />
                            </div>
                            <p className="font-manrope font-semibold text-[var(--gray-brown)] text-sm md:text-[0.78rem]" >Add team details to sign up for the event</p>
                          </div>
                        )}

                        {(showTeamForm || eventData.isFull) && (

                          <form className="flex flex-col px-4 md:px-0 gap-3">
                            <h1 className="text-[var(--dark-blue)] text-[1.5rem] font-ClashGrotesk font-medium ml-2">1. <span className="ml-3"> Select your team</span></h1>

                            <h1 className="text-base md:text-xs font-semibold font-manrope text-[var(--gray-brown)] md:ml-10 pt-2 md:pt-0 hidden md:block">
                              Organizer Contact Details:
                            </h1>{" "}

                            {Array.from({ length: count }, (_, i) => (
                              <React.Fragment key={i}>
                                {i === 0 ? (
                                  <>
                                    <div id="form-mainPlayer-part-checkout" className="flex flex-col md:flex-row gap-4 w-full text-[var(--dark-blue)] font-manrope font-semibold border border-solid rounded-3xl md:border-none p-8 md:p-0 ">
                                      <p className="font-semibold font-manrope text-[var(--dark-blue)] md:hidden">Your Details</p>
                                      <p className="text-[var(--dark-blue)]  border-[var(--dark-blue)] border-solid border-2 rounded-full w-6 h-6  p-2 md:flex justify-center items-center mt-2 hidden ">{i + 1}</p>
                                      <div className="flex flex-col w-full gap-4">
                                        <div className="flex flex-col md:flex-row gap-4  ">
                                          <div className="flex flex-col w-full">
                                            <input required
                                              type="text"
                                              placeholder="First Name*"
                                              name="FirstName"
                                              value={formData.FirstName}
                                              onChange={handleChange}
                                              className={` border py-4 p-2 rounded-lg w-full  bg-[var(--white)] md:text-xs ${errors.FirstName && shouldShowError('FirstName') ? 'border-red-500' : 'border-[var(--input-border-gray)]'}`}
                                            />
                                            {errors.FirstName && shouldShowError('FirstName') && (
                                              <p className="text-red-500 text-xs font-manrope mt-1">{errors.FirstName}</p>
                                            )}
                                          </div>
                                          <div className="flex flex-col w-full">
                                            <input required
                                              type="text"
                                              placeholder="Last Name*"
                                              name="LastName"
                                              value={formData.LastName}
                                              onChange={handleChange}
                                              className={`border py-4 p-2 rounded-lg w-full  bg-[var(--white)] md:text-xs ${errors.LastName && shouldShowError('LastName') ? 'border-red-500' : 'border-[var(--input-border-gray)]'} `}
                                            />
                                            {errors.LastName && shouldShowError('LastName') && (
                                              <p className="text-red-500 text-xs font-manrope mt-1">{errors.LastName}</p>
                                            )}
                                          </div>
                                        </div>
                                        <div className="flex flex-col md:flex-row gap-4">
                                          <div className="flex flex-col w-full">
                                            <input
                                              type="Email"
                                              placeholder="Email*"
                                              name="Email"
                                              value={formData.Email}
                                              onChange={handleChange}
                                              className={`border py-4  p-2 rounded-lg w-full  bg-[var(--white)] text-[var(--dark-blue)] md:text-xs ${errors.Email && shouldShowError('Email') ? 'border-red-500' : 'border-[var(--input-border-gray)]'}`}
                                            />
                                            {errors.Email && shouldShowError('Email') && (
                                              <p className="text-red-500 text-xs font-manrope mt-1">{errors.Email}</p>
                                            )}
                                          </div>
                                          <div className="flex flex-col w-full">
                                            <select id="custom-select-1-checkout" name="Gender" value={formData.Gender} onChange={handleChange} className={`select-button custom-select select md:py-4  md:p-2 h-[3.2rem]  w-full  bg-white max-w-xs  text-[var(--dark-blue)] bg-[(--white)] font-semibold md:text-xs ${errors.Gender && shouldShowError('Gender') ? 'border-red-500' : 'border-[var(--input-border-gray)]'} `} required>
                                              <option disabled selected hidden value="" className="text-[var(--gray-brown)] font-ClashGrotesk font-medium ">Gender</option>
                                              <option value="Man" >Man</option>
                                              <option value="Woman" >Woman</option>
                                              <option value="Non-Binary">Non-Binary</option>
                                            </select>
                                            {errors.Gender && shouldShowError('Gender') && (
                                              <p className="text-red-500 text-xs font-manrope mt-1">{errors.Gender}</p>
                                            )}
                                          </div>
                                          <div className="flex flex-col w-full">
                                            <input
                                              type="tel"
                                              placeholder="Mobile*"
                                              name="Phone"
                                              value={formData.Phone}
                                              onChange={handleChange}
                                              className={`border  py-4 p-2 rounded-lg w-full  bg-[var(--white)] text-[var(--dark-blue)] md:text-xs ${errors.Phone && shouldShowError('Phone') ? 'border-red-500' : 'border-[var(--input-border-gray)]'} `}
                                            />
                                            {errors.Phone && shouldShowError('Phone') && (
                                              <p className="text-red-500 text-xs font-manrope mt-1">{errors.Phone}</p>
                                            )}
                                          </div>

                                        </div>
                                      </div>


                                    </div>


                                    {!showTeamForm && !eventData.isFull && (
                                      <hr className="text-[var(--dull-white)] border-[1.04px] md:mb-1 hidden md:block mr-7" />
                                    )}



                                  </>

                                ) : (
                                  <>
                                    {i === 1 ? (<>
                                      <br />
                                      <p className="mt-1 md:ml-10 md:text-xs font-manrope font-semibold text-[var(--gray-brown)] hidden md:block">
                                        Team player details
                                      </p>
                                    </>
                                    ) : (
                                      <p>

                                      </p>
                                    )}

                                    <div id="form-loop-part-checkout" className="flex flex-col md:flex-row gap-4 w-full md:items-start font-manrope  text-[var(--dark-blue)] mb-2 font-semibold border border-solid rounded-3xl md:border-none p-8 md:p-0  ">
                                      <span className="flex items-center gap-2 md:mt-2">
                                        <p className="text-[var(--dark-blue)]  border-[var(--dark-blue)] border-solid border-2 rounded-full w-5 h-5 md:w-6 md:h-6  p-2 flex justify-center items-center mt-1 text-sm md:text-base ">{i + 1}</p>

                                        <p className="font-semibold font-manrope text-[var(--dark-blue)] md:hidden pt-1">Team Member {i}</p>

                                      </span>

                                      <div className="flex flex-col w-full gap-4">
                                        <div className="flex flex-col md:flex-row gap-4 w-full ">
                                          <div className="flex flex-col w-full">
                                            <input
                                              type="text"
                                              placeholder="First Name*"
                                              name="first_name"
                                              value={teamMembers[i].FirstName}
                                              onChange={(e) => handleTeamInputChange(i, 'FirstName', e.target.value)}
                                              required
                                              className={`border py-4 p-2 rounded-lg w-full bg-[var(--white)] md:text-xs ${teamErrors?.[i]?.FirstName && shouldShowTeamError(i, 'FirstName') ? "border-red-500" : 'border-[var(--input-border-gray)]'}`}
                                            />
                                            {teamErrors?.[i]?.FirstName && shouldShowTeamError(i, 'FirstName') && (
                                              <p className="text-red-500 text-xs font-manrope mt-1">{teamErrors[i].FirstName}</p>
                                            )}
                                          </div>
                                          <div className="flex flex-col w-full">
                                            <input
                                              type="text"
                                              placeholder="Last Name*"
                                              name="last_name"
                                              value={teamMembers[i].LastName}
                                              onChange={(e) => handleTeamInputChange(i, 'LastName', e.target.value)}
                                              required
                                              className={`border py-4 p-2 rounded-lg w-full bg-[var(--white)] md:text-xs ${teamErrors?.[i]?.LastName && shouldShowTeamError(i, 'LastName') ? "border-red-500" : "border-[var(--input-border-gray)]"}`}
                                            />
                                            {teamErrors?.[i]?.LastName && shouldShowTeamError(i, 'LastName') && (
                                              <p className="text-red-500 text-xs font-manrope mt-1">{teamErrors[i].LastName}</p>
                                            )}
                                          </div>
                                        </div>
                                        <div className="flex flex-col md:flex-row gap-4">

                                          <div className="flex flex-col w-full">
                                            <select name="Gender"
                                              id="custom-select-2-checkout"
                                              value={teamMembers[i].Gender}
                                              onChange={(e) => handleTeamInputChange(i, 'Gender', e.target.value)}
                                              required
                                              className={`select-button select md:py-4 p-2 h-[3.2rem]   w-full bg-white  text-[var(--dark-blue)] bg-[var(--white)] font-semibold md:text-xs ${teamErrors?.[i]?.Gender && shouldShowTeamError(i, 'Gender') ? "border-red-500" : "border-[var(--input-border-gray)] "}`} >
                                              <option disabled selected hidden value="" className="text-[var(--gray-brown)] font-ClashGrotesk font-medium ">Gender</option>
                                              <option value="Man" >Man</option>
                                              <option value="Woman" >Woman</option>
                                              <option value="Non-Binary">Non-Binary</option>
                                            </select>
                                            {teamErrors?.[i]?.Gender && shouldShowTeamError(i, 'Gender') && (
                                              <p className="text-red-500 text-xs font-manrope mt-1">{teamErrors[i].Gender}</p>
                                            )}
                                          </div>
                                          <div className="flex flex-col w-full">
                                            <input
                                              type="tel"
                                              placeholder="Mobile*"
                                              name="mobile"
                                              value={teamMembers[i].Phone}
                                              onChange={(e) => handleTeamInputChange(i, 'Phone', e.target.value)}
                                              required
                                              className={`border py-4 p-2 rounded-lg w-full bg-[var(--white)] text-[var(--dark-blue)] md:text-xs ${teamErrors?.[i]?.Phone && shouldShowTeamError(i, 'Phone') ? "border-red-500" : "border-[var(--input-border-gray)]"}`}
                                            />
                                            {teamErrors?.[i]?.Phone && shouldShowTeamError(i, 'Phone') && (
                                              <p className="text-red-500 text-xs font-manrope mt-1">{teamErrors[i].Phone}</p>
                                            )}
                                          </div>

                                        </div>
                                      </div>
                                    </div>
                                  </>
                                )}


                              </React.Fragment>
                            ))}

                          </form>
                        )}

                      </div>
                      <hr className="text-[var(--dull-white)] border-[1.04px] md:mb-1 hidden md:block mr-5" />

                      {!eventData.isFull && (
                        <div id="second-section-checkout-modal" className="py-4 ml-2" ref={chooseWhoPaysRef}>
                          <div className="flex justify-between items-center ">
                            <h1 className="text-[var(--dark-blue)] text-[1.5rem] font-ClashGrotesk font-medium">2. <span className="ml-1">Choose who pays</span>
                              <span className="ml-3 inline">
                                <img onClick={() => setShowOverlayModal(true)} className="inline" src={infoIcon} alt="" />
                              </span>
                            </h1>
                            <img onClick={toggleSplitPaymentView}
                              src={DownArrow} className="cursor-pointer mr-7" />
                          </div>
                          {!showSplitPaymentView && (
                            <p className="font-manrope font-semibold text-[var(--dark-blue)] text-[0.95rem] md:text-[0.78rem]" >Pay for your entire team, or let each player pay for themselves.</p>
                          )}



                          {showSplitPaymentView && (
                            <div>
                              <p className="font-manrope font-semibold text-[var(--dark-blue)] text-[0.95rem] md:text-[0.78rem] md:ml-7 md:mr-8 " >Pay for your entire team, or let each player pay for themselves. Payment methods are charged when the order is placed. </p>

                              <img src={SplitPaymentCard} alt="split payment card image" className="mt-6 w-full hidden md:block" />

                              <div className="mt-7 ml-3 md:ml-9 flex justify-between items-center mr-8 md:mr-16">
                                <span className="flex gap-x-2 font-manrope text-[var(--dark-black)] text-base font-semibold  " >
                                  <img className="w-5" src={SinglePersonLogo} alt="" /> I pay for my team
                                </span>

                                {/* Radio btn split case */}
                                <div onClick={handleNonSplitScenario}>
                                  {paymentNonSplitRadioBtn === false ?
                                    (<img src={UncheckedRadio} alt="" />) :
                                    (<img src={CheckedRadio} alt="" />)
                                  }
                                </div>


                              </div>
                              {paymentNonSplitRadioBtn && (
                                <div className="text-[#707070] font-manrope font-semibold text-xs ml-3 mr-3 mt-3 md:hidden">You can pay using INR for your team</div>
                              )}


                              <hr className="text-[var(--dull-white)] border-[1.04px] md:mb-1  my-5 ml-3 md:ml-9 mr-8 md:mr-16" />
                              <div className="mt-5 ml-3 md:ml-9 flex justify-between items-center mr-8 md:mr-16">
                                <span className="flex gap-x-2 font-manrope text-[var(--dark-black)] text-base font-semibold  " >
                                  <img className="w-5" src={MultiplePersonLogo} alt="" /> Everyone pays for themselves
                                </span>



                                {/* Radio btn non-split */}
                                <div onClick={handleSplitScenario}>
                                  {paymentSplitRadioBtn === false ?
                                    (<img src={UncheckedRadio} alt="" />) :
                                    (<img src={CheckedRadio} alt="" />)
                                  }
                                </div>



                              </div>
                              {paymentSplitRadioBtn && (
                                <div className="text-[#707070] font-manrope font-semibold text-xs ml-3 mr-3 mt-3 md:hidden">Your team members will receive an invite for the event, where they can make their payment in the allotted time</div>
                              )}

                              {((submitAttempted || chooseWhoPaysTouched) && !eventData.isFull && count > 1 && splitPaymentValue === null) && (
                                <p className="text-red-500 text-xs font-manrope mt-2 ml-3 md:ml-9">Please complete the "Choose who pays" section.</p>
                              )}

                            </div>
                          )}
                        </div>
                      )}
                      {/* Second section of checkout modal */}

                      {!showSplitPaymentView && !eventData.isFull && (
                        <hr className="text-[var(--dull-white)] border-[1.04px] md:mb-1 hidden md:block mr-5" />
                      )}

                    </>
                  )}



                </div>
              </div>
            </div>
          </div>

          {/* Right Side: Order Summary */}
          <div id="right-part-checkout" className="w-[90%] mx-auto md:mx-0 flex flex-col  md:gap-2 md:w-[42%] bg-[var(--background-light-gray)] pt-2 px-6 md:p-10 mt-4 md:mb-0 md:mt-0 md:max-h-[30%]  md:rounded-r-3xl rounded-3xl md:rounded-none  md:rounded-bl-none relative ">
            <div className="flex justify-between">
              <h3 id="right-part-checkout-heading" className="font-semibold font-manrope text-base text-[var(--dark-blue)] hidden md:block">
                Order Summary
              </h3>
            </div>

            {/* Event Title and description for right side only for web view*/}
            <div className="mt-4 font-manrope font-semibold hidden md:block">
              <p className="text-[var(--dark-blue)] font-bold text-xl mb-1">
                {eventData.EventTitle} x {count}
              </p>
              <hr className="text-[var(--input-border-gray)]  border-[1.5px] my-4 md:my-2 " />
              <p className="text-[var(--gray-brown)]  mt-2 flex items-center space-x-2">
                <i className="far fa-calendar-alt"></i>
                <span className="flex gap-2 md:text-base">
                  <img src={calendarVector} alt="calendar" />
                  {formattedDates.startDate}
                  {formattedDates.endDate > formattedDates.startDate ? ` - ${formattedDates.endDate}` : ''}
                </span>
              </p>
              <hr className="text-[var(--input-border-gray)]  border-[1.5px] my-2 hidden md:block" />
              <p className="text-[var(--gray-brown)] mt-2 flex items-center space-x-2">
                <i className="far fa-clock"></i>
                <span className="flex gap-2 md:text-base">
                  <img src={timeVector} alt="clock" />
                  {formattedDates.StartTimeStamp} -{" "}
                  {formattedDates.EndTimeStamp}
                </span>
              </p>
              <hr className="text-[var(--input-border-gray)]  border-[1.5px] my-2 hidden md:block" />
              <p className="text-[var(--gray-brown)] mt-2 flex items-center space-x-2">
                <i className="fas fa-map-marker-alt"></i>
                <span className="flex gap-2 md:text-base">
                  <img src={locationVector} alt="location" />
                  {eventData.venue.VenueName}{", "}
                  {eventData.venue.VenueAddress.city}
                </span>
              </p>
              <hr className="text-[var(--input-border-gray)] border-[1.5px] my-2 mt-4 md:mt-0" />
            </div>

            {/* Event Title and description as accordian for mobile device */}
            <div id="accordian-container-checkout" className="md:hidden font-manrope font-semibold">
              <div className="collapse collapse-arrow">
                <input className="bg-red-300" type="checkbox" name="my-accordion-1" checked={isMobileEventAccordionOpen} onChange={(e) => setIsMobileEventAccordionOpen(e.target.checked)} />
                {/* Title here */}
                <div id="collapse-title-accordian-checkout" className="collapse-title text-xl font-medium" >
                  <p id="event-title-accordian" className="text-[var(--dark-blue)] font-bold text-xl mt-1 -mb-1 -ml-3">
                    {eventData.EventTitle} x {count}
                  </p>
                  <hr className="text-[var(--input-border-gray)]  border-[1.5px] my-2 -mb-8 md:my-2 -ml-3" />
                </div>
                <div id="collapse-content-accordian-checkout" className="collapse-content p-0">
                  <p className="text-[var(--gray-brown)]  mt-2 flex items-center space-x-2">
                    <i className="far fa-calendar-alt"></i>
                    <span id="calendar-accordian" className="flex gap-2 md:text-base">
                      <img id="calendar-img-accordian" src={calendarVector} alt="calendar" />
                      {formattedDates.startDate}
                    </span>
                  </p>

                  <p className="text-[var(--gray-brown)] mt-2 flex items-center space-x-2">
                    <i className="far fa-clock"></i>
                    <span id="time-accordian" className="flex gap-2 md:text-base">
                      <img id="time-img-accordian" src={timeVector} alt="clock" />
                      {formattedDates.StartTimeStamp} -{" "}
                      {formattedDates.EndTimeStamp}
                    </span>
                  </p>

                  <p className="text-[var(--gray-brown)] mt-2 flex items-center space-x-2">
                    <i className="fas fa-map-marker-alt"></i>
                    <span id="location-accordian" className="flex gap-2 md:text-base">
                      <img id="location-img-accordian" src={locationVector} alt="location" />
                      {eventData.venue.VenueAddress.city},{" "}
                      {eventData.venue.VenueAddress.state},{" "}
                      {eventData.venue.VenueAddress.country},{" "}
                      {eventData.venue.VenueAddress.pincode}
                    </span>
                  </p>
                  <hr className="text-[var(--input-border-gray)] border-[1.5px] mt-4  md:mt-0 md:hidden" />
                </div>

              </div>
            </div>



            {/* Checkbox for subscription and terms and conditions */}
            <form id="agree-checkboxForm-checkout" className=" md:mt-2 mb-1 md:mb-0">
              <div id="subscription-checkbox-mobile" className="md:mt-4 font-manrope font-semibold text-sm text-[var(--dark-blue)]">
                <div className="checkbox-container md:flex  space-x-2 flex items-start ">
                  <input className="custom-checkbox" type="checkbox" defaultChecked id="newsletter" name="subscribeUpdates" checked={formData.subscribeUpdates} onChange={handleChange} />
                  <label className="flex shrink-0 mt-[0.15rem] md:mt-0" htmlFor="newsletter"></label>
                  <span>Keep me updated on more events and news from Net Gala</span>
                </div>
                <div className="checkbox-container flex items-start  space-x-2 mt-2">
                  <input className={'custom-checkbox'} type="checkbox" defaultChecked id="terms" name="agreeTerms" checked={formData.agreeTerms} onChange={handleChange} />
                  <label className="flex shrink-0" htmlFor="terms" style={errors.agreeTerms ? { borderColor: 'rgba(239, 68, 68, 1)' } : {}}>
                  </label>
                  <div>
                    <span>
                      I agree to the{" "}
                      <span className="underline">
                        <Link to="/terms" target="_blank" className="hover:text-[var(--reddish-brown)]">
                          Net Gala Terms of Service
                        </Link>
                      </span>
                    </span>
                    {errors.agreeTerms && shouldShowError('agreeTerms') && (
                      <p className="text-red-500 text-xs font-manrope mt-1">{errors.agreeTerms}</p>
                    )}
                  </div>
                </div>

              </div>
            </form>


            <p className="font-normal font-ClashGrotesk text-2xl text-[var(--dark-blue)] mt-1 md:mt-10">
              {splitPaymentValue == null || splitPaymentValue == true ?
                (
                  <span className="font-medium text-xl md:text-[1.87rem] ml-2 md:ml-0">₹{formatPrice(eventData.Price_In_Paisa ?? 0)} <span className="font-normal text-[1.1rem]" >per person</span> <span className="text-sm font-normal">(Inclusive of GST)</span></span>
                ) : (
                  <span className="font-medium text-xl md:text-[1.87rem] ml-2 md:ml-0"> Total: ₹{formatPrice((eventData.Price_In_Paisa ?? 0) * count)} <span className="text-sm font-normal">(Inclusive of GST)</span></span>
                )
              }

            </p>

            <div className="md:mt-auto">
              {/* Event Price here */}
              <div id="checkout-event-price" className="md:mt-4 md:pt-4 mb-2 md:mb-0">

              </div>


              {/*  CTA button here */}
              <button
                onClick={handleSubmit}
                id="proceed-to-payment-button"
                className={`w-full mb-2 md:mb-0 mx-auto  font-manrope  py-4 rounded-2xl   md:text-[1.1rem] transition-colors duration-300 ease-in-out 
                      ${eventData.isFull ?
                    (!isFormValid ?
                      'bg-[var(--netGala-green-disabled-btn)] text-[var(--netGala-green-disabled-btn-txt)] font-bold cursor-default' :
                      'bg-[var(--button-green)] text-[var(--green-button-text-black)] font-bold'
                    ) :
                    (isFormValid ?
                      'bg-[var(--purple-blue)] text-[var(--white)] font-semibold' :
                      'bg-[var(--gray-brown)] text-[var(--white)] font-semibold cursor-default'
                    )}`}
              >
                {loading ? (
                  <ClipLoader color="white" size={20} />
                ) : (
                  eventData.isFull ? "Join Waitlist" : "Continue to Payment"
                )}
              </button>

              {/* Error message display */}
              {errorDisplayMessage && (
                <div className=" flex justify-center text-red-500 text-base mx-auto md:text-base md:mt-2">
                  {errorDisplayMessage}
                </div>
              )}

              {/* Form validation error messages - only show after submit attempt */}
              {submitAttempted && (() => {
                const hasNonSplitPaymentErrors = Object.keys(errors || {}).some((key) => key !== 'splitPayment');
                const hasTeamErrors = Array.isArray(teamErrors) && teamErrors.some((e) => e && Object.keys(e).length > 0);
                const hasFormErrors = hasNonSplitPaymentErrors || hasTeamErrors;
                const hasChooseWhoPaysError = (!eventData.isFull && count > 1 && splitPaymentValue === null);

                if (hasFormErrors) {
                  return (
                    <div className="md:mt-3 mt-1 mb-1 text-red-500 text-sm font-manrope text-center">
                      Please enter form details correctly.
                    </div>
                  );
                }

                if (!eventData.isFull && count > 1 && splitPaymentValue === null && hasChooseWhoPaysError) {
                  return (
                    <div className="md:mt-3 mt-1 text-red-500 text-sm font-manrope text-center">
                      Please complete the "Choose who pays" section.
                    </div>
                  );
                }

                return null;
              })()}

            </div>

          </div>
        </div>

      ) : (
        <LeaveCheckout onStay={handleStayClick} onLeave={handleLeaveClick} />
      )}

      {/* Overlay Modal for Team Events (Mobile Only) */}
      {showOverlayModal && count > 1 && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 md:hidden">
          <div className=" rounded-2xl w-[90%] max-w-md max-h-[80vh] overflow-y-auto relative mx-4"
            style={{ backgroundImage: `url(${SplitPaymentOverlayBackground})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
            {/* Modal Header with Cross Button */}
            <div className="flex justify-between items-center pt-6 pb-3 px-6 border-b border-gray-200 mt-5">
              <h2 className="text-2xl font-medium text-[var(--dark-blue)] font-ClashGrotesk text-center flex-1">
                Enjoy flexible team payments through NetGala
              </h2>
              <button
                onClick={() => setShowOverlayModal(false)}
                className="absolute top-2 right-4 text-4xl font-light text-[var(--purple-blue)] w-8 h-8 flex items-center justify-center transition-colors"
              >
                ×
              </button>
            </div>

            {/* Modal Content */}
            <div className="  pb-6 px-6">
              {/* Illustration image */}
              <div className="flex justify-center my-3">
                <img src={SplitPaymentMobile} alt="Flexible team payments" className="w-36 h-auto" />
              </div>

              <div className="space-y-3 text-[var(--dark-blue)] font-medium">
                <div className="flex items-start space-x-2">
                  <div className="w-6 h-6  flex items-center justify-center flex-shrink-0 mt-0.5">
                    <span >
                      <img className="w-4" src={coinVector} alt="" />
                    </span>
                  </div>
                  <p className="text-sm  leading-relaxed font-manrope">
                    Pay for your <span className="font-bold">team</span>  or invite each player to pay for <span className="font-bold">themselves</span>.
                  </p>
                </div>

                <div className="flex items-start space-x-2">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <span>
                      <img className="w-4" src={coinVector} alt="" />
                    </span>
                  </div>
                  <p className="text-sm  leading-relaxed font-manrope">
                    If you decide to cover your team's fees, you can use member <span className="font-bold">credits</span> or pay <span className="font-bold">online</span>.
                  </p>
                </div>

                <div className="flex items-start space-x-2">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <span>
                      <img className="w-4" src={coinVector} alt="" />
                    </span>
                  </div>
                  <p className="text-sm  leading-relaxed font-manrope">
                    Team's spot is only confirmed when <span className="font-bold">all payments</span> are completed.
                  </p>
                </div>

                <div className="flex items-start space-x-2">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <span>
                      <img className="w-4" src={coinVector} alt="" />
                    </span>
                  </div>
                  <p className="text-sm  leading-relaxed font-manrope">
                    Credits and payments are <span className="font-bold">refunded</span> within 2-4 business days if cancelled.
                  </p>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <span>
                      <img className="w-4" src={coinVector} alt="" />
                    </span>
                  </div>
                  <p className="text-sm  leading-relaxed font-manrope">
                    Credit payments are exclusive to <span className="font-bold">members</span> and can only be made through the <span className="font-bold">Net Gala app</span> .
                  </p>
                </div>
              </div>

              <div className="mt-2 pt-4  border-gray-200">
                <button
                  onClick={() => setShowOverlayModal(false)}
                  className="w-full bg-[var(--purple-blue)] text-white py-3 rounded-xl font-semibold font-manrope text-base transition-colors hover:bg-opacity-90"
                >
                  Got it
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CheckoutModal;
